import React, { forwardRef, ReactElement } from 'react';
import cx from "classnames";
import styled from "styled-components";
import IBuildrProps from 'src/utilities/IBuildrProps';
import { IInputGroupProps } from '../FormGroup';
import { IInputTextProps } from '../InputText';
import { ITextAreaProps } from '../TextArea';
import { IDropdownProps } from '../FormDropdown';

export interface IFormRowProps extends IBuildrProps {
    children: any;
    isWhite: boolean;
}

export default styled(forwardRef(function FormRow({ className, children, editorClassObj, cmsId, isWhite }: IFormRowProps, ref: any) {
    return (
        <div data-id={cmsId} ref={ref} className={cx('form-row m-0', className, editorClassObj)}>
            {React.Children.map(children,
                (child: ReactElement<IInputGroupProps|IInputTextProps|ITextAreaProps|IDropdownProps>) => {
                    return React.cloneElement(child, {
                        isWhite,
                    });
                })
            }
        </div>
    )
}))``;
